module.exports = __webpack_public_path__ + "static/br-1c51b83c8bdde235685c62e82d7c60c0.png";